import moment from 'moment';
import { Model } from '@/models';

export interface NetworkExport {
  identifier: string;
  investigationIdentifier: string;
  surveyIdentifier: string[];
  creatorIdentifier: string;
  editorIdentifier: string;
  key: string;
  contentType: string;
  storedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  creatorBase64Identifier: string;
  creatorAvatar: string;
  creatorNames: string;
  exportFormNames: string[];
  error: ExportError | null;
}

export interface PostExportOptions {
  caseIdentifiers: string[];
}

export interface PostExport {
  formIdentifiers: string[];
  caseIdentifiers?: string[];
  choiceLabels: boolean;
  format: string;
  period?: {
    start: number;
    end: number;
  },
  includeArchive: boolean;
  files?: boolean;
  metadata?: boolean;
  shiftDates?: boolean;
  header?: string;
  timezone?: string;
}

export interface ExportColumnHeader {
  label: string;
  value: string;
}

export interface PostExportResponse {
  identifier?: string;
}

export interface ExportError {
  message: string,
  name: string,
  stack: string,
}

interface IExport {
  identifier: string;
  contentType: string;
  createdAt: Date;
  storedAt?: Date;
  creatorAvatar: string;
  creatorNames: string;
  fileKey: string;
  exportFormNames: string | string[];
  error: ExportError | null;
}

export class ExportModel extends Model {
  identifier: string;
  contentType: string;
  createdAt: Date;
  storedAt?: Date;
  avatar: string;
  creatorNames: string;
  fileKey: string;
  exportFormNames: string | string[];
  preparing?: boolean;
  error: ExportError | null;

  constructor({
    identifier,
    contentType,
    createdAt,
    storedAt,
    creatorAvatar,
    creatorNames,
    fileKey,
    exportFormNames,
    error
  }: IExport) {
    super();
    this.identifier = identifier;
    this.contentType = contentType;
    this.createdAt = createdAt;
    this.storedAt = storedAt;
    this.avatar = creatorAvatar;
    this.creatorNames = creatorNames;
    this.fileKey = fileKey;
    this.exportFormNames = exportFormNames;
    this.error = error;
  }

  static mapFromBackend(networkExport: NetworkExport) {
    return new ExportModel({
      identifier: networkExport.identifier,
      contentType:
        networkExport.contentType.includes('csv') ?
          networkExport.contentType.split('/')[1] :
          networkExport.contentType.includes('sheet') ? 'xlsx' : '',
      createdAt: moment(networkExport.createdAt).toDate(),
      storedAt: networkExport.storedAt ? moment(networkExport.storedAt).toDate() : undefined,
      creatorAvatar: networkExport.creatorAvatar,
      creatorNames: networkExport.creatorNames,
      fileKey: networkExport.key,
      exportFormNames: networkExport.exportFormNames.length > 1 ? 'Multiple forms' : networkExport.exportFormNames[0],
      error: networkExport.error
    });
  }
}
